"use client"
import React from 'react'
import { ReactLenis } from '@/components/common/SmoothScroll'
import Navbar from '@/components/navigation/Navbar'
import Link from 'next/link'
import Image from 'next/image'

const MainLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <header >
                <Navbar />
            </header>
            <ReactLenis root>
                {children}
            </ReactLenis>
            <Link
                href="https://ebadge.bestweb.lk/api/v1/clicked/servicedapartments.lk/BestWeb/2025/Rate_Us"
                target="_blank"
                className="bottom-4 left-6 z-[100] fixed w-20 sm:w-24 md:w-28 lg:w-32 h-20 sm:h-24 md:h-28 lg:h-32"
            >
                <Image
                    src="https://ebadge.bestweb.lk/eBadgeSystem/domainNames/servicedapartments.lk/BestWeb/2025/Rate_Us/image.png"
                    alt="logo"
                    className="w-20 h-20"
                    fill
                    loading="eager"
                />
            </Link>
        </>
    )
}

export default MainLayout